import { ImpersonatedUser } from "iron-session";
import useSWR, { SWRResponse } from "swr";
import { IUseImpersonatedUser } from "./types";
import { clearOrdersStore } from "@portal/externalStore/ordersStore";
import { isAdvisor } from "@portal/helpers/session/portalRoleStrings";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const useImpersonatedUser: IUseImpersonatedUser = () => {
  const { session, update } = useSession();

  const { data, error, isLoading, mutate }: SWRResponse<ImpersonatedUser, unknown> = useSWR(
    isAdvisor(session?.role) ? `/api/internal/impersonate` : null,
    commonFetcher<ImpersonatedUser>,
    commonSwrConfig(update),
  );

  const storeImpersonatedUser = (user: ImpersonatedUser) => {
    return fetch(`/api/internal/impersonate`, {
      method: "POST",
      headers: [["accepts", "application/json"]],
      body: JSON.stringify(user),
    }).then(res => {
      clearOrdersStore();
      mutate();
      return res.json();
    });
  };

  const dropImpersonatedUser = () => {
    return fetch(`/api/internal/impersonate`, {
      method: "DELETE",
      headers: [["accepts", "application/json"]],
    }).then(() => {
      clearOrdersStore();
      mutate();
      return;
    });
  };

  return {
    data,
    error,
    isLoading,
    storeImpersonatedUser,
    dropImpersonatedUser,
  };
};

export default useImpersonatedUser;
